import { PaletteMode } from '@mui/material'

export const THEME_MODE_ITEM_NAME = 'mode'

export const getPersistedThemeMode = () => {
  return structuredClone(localStorage.getItem(THEME_MODE_ITEM_NAME)) as PaletteMode
}

export const persistThemeMode = (value: PaletteMode) => {
  localStorage.setItem(THEME_MODE_ITEM_NAME, value)
}
